var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_378_641)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.3438 21.3125C26.2289 21.3125 31 16.5414 31 10.6562C31 4.77109 26.2289 0 20.3438 0C14.4586 0 9.6875 4.77109 9.6875 10.6562C9.6875 11.7885 9.86309 12.8844 10.19 13.9076L0.423828 23.6738C0.151367 23.9463 0 24.3156 0 24.7031V29.5469C0 30.3521 0.647852 31 1.45312 31H6.29688C7.10215 31 7.75 30.3521 7.75 29.5469V27.125H10.1719C10.9771 27.125 11.625 26.4771 11.625 25.6719V23.25H14.0469C14.4344 23.25 14.8037 23.0986 15.0762 22.8262L17.0924 20.81C18.1156 21.1369 19.2115 21.3125 20.3438 21.3125ZM22.7656 5.8125C23.4079 5.8125 24.024 6.06766 24.4781 6.52185C24.9323 6.97604 25.1875 7.59205 25.1875 8.23438C25.1875 8.8767 24.9323 9.49271 24.4781 9.9469C24.024 10.4011 23.4079 10.6562 22.7656 10.6562C22.1233 10.6562 21.5073 10.4011 21.0531 9.9469C20.5989 9.49271 20.3438 8.8767 20.3438 8.23438C20.3438 7.59205 20.5989 6.97604 21.0531 6.52185C21.5073 6.06766 22.1233 5.8125 22.7656 5.8125Z",
    fill: "#233C7E",
    fillOpacity: 0.25
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_378_641"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 31,
    height: 31,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKey);
export default __webpack_public_path__ + "static/media/key.9bbd58a56e8d8f0505f560b283d6cda2.svg";
export { ForwardRef as ReactComponent };